import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Row, Col, Modal, Dropdown, Badge, Button, Table, Tab, Tabs } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import { Link, useHistory } from 'react-router-dom';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import { withRFSToken } from '../../../../Services/axios';
import { toast } from 'react-toastify';
import GalleryView from './Common/GalleryView.js';
import edit from "../../../../assets/images/edit.png";
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const DriverPlanning = () => {

  const isMounted = useRef(false);

  //wrong 
  const [selectedFile, setSelectedFile] = useState(null);
  const [show, setShow] = useState(false);
  const [modalData, setModalData] = useState(null);

  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [totalRows, setTotalRows] = useState({});
  const [totalRowsR, setTotalRowsR] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [activeTab, setActiveTab] = useState('Active');
  const gridRefs = {
    Active: useRef(null),
    Archived: useRef(null),
  };
  const [gridData, setGridData] = useState({
    Active: [],
    Archived: [],
  });

  useEffect(() => {
    if (isMounted.current) return;
    setIsLoading(false);
    setGridData({ Active: {} });
    isMounted.current = true;
  }, []);

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);

  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);
    }
  }
  const handleDropdownItemClick = () => {

  }

  const [galleryOpen, setGalleryOpen] = useState(false);
  const showGalleryModal = () => {
    setGalleryOpen(true);
  };
  const closeGalleryModal = () => {
    setGalleryOpen(false);
  };

  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    if (gridRefs[activeTab]?.current) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      let tabType = '';
      if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'I' }
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'driver_id', type: 'string' },
          { name: 'driver_name', type: 'string' },
          { name: 'org_name', type: 'string' },
          { name: 'acn_id', type: 'string' },
          { name: 'vehicle_id', type: 'string' },
          { name: 'trailer_id', type: 'string' },
          { name: 'remarks', type: 'string' },
        ],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}forwarder-shipment-planning/driver-list`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          setTotalRows({ totalUlds: data.activeCount });
          setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
     const columns = [
        {
          text: 'Actions',
          cellsrenderer: function () {
            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
          },
          width: '5%', filterable: false,
        },
        { text: 'Driver Name', filtertype: 'input', datafield: 'driver_name', width: '10%', cellclassname: '', },
        { text: 'Trucking Company', filtertype: 'input', datafield: 'org_name', width: '10%', cellclassname: '', },
        { text: 'ACN ID', filtertype: 'input', datafield: 'acn_id', width: '10%', cellclassname: '', },
        { text: 'Vehicle ID', filtertype: 'input', datafield: 'vehicle_id', width: '10%', cellclassname: '', },
        { text: 'Trailer ID', filtertype: 'input', datafield: 'trailer_id', width: '10%', cellclassname: '', },
        { text: 'Remarks', filtertype: 'input', datafield: 'remarks', width: '10%', cellclassname: '', },
      ];
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 20,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
        ready: function () {
          localStorgeFilter();
        },
      };
       window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr("row-id");
        const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid("getrowid", rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid("getpaginginformation");
          const pageIndex = pagingInfo.pagenum; 
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid("getrowdata", globalIndex);
          if (rowData) {
            setDriverData(rowData);
            setDriverModal(true);
          } else {
            console.error("No data found for the given row index.");
          }
        } else {
          console.error("Bound index could not be retrieved. Check the row index and data binding.");
        }
      });
      window.$(gridRefs[activeTab].current).on('click', '.screen', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
        console.log("🚀 ~ rowData:", rowData)
      });
      window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const uldNumber = selectedRow.airway_bill;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }
          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.airway_bill === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.airway_bill;
          setGridSelect(prevSelection => prevSelection.filter(row => row.airway_bill !== unselectedRowId));
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
        }
      });
      window.$(gridRefs[activeTab].current).off('cellclick');
      window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        if (event.args.columnindex > 1 && event.args.columnindex !== 4) {
          console.log("cell click")
          // if (gridSelect) {
          //   gridSelect.forEach(item => {
          //     const selectedRowBoundIndex = item.boundindex;
          //     window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
          //   });
          // }
          // loadDetails(args.uld_number);
          // setSelectedRowData(args)
          setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
          }, 30);
        }
      });
    }
  }, [gridData]);

  function localStorgeFilter() {
    let savedFilters = localStorage.getItem('srFilter');
    if (savedFilters) {
      savedFilters = JSON.parse(localStorage.getItem('srFilter'));
      savedFilters.forEach(element => {
        const filterValue = element.filters[0].value;
        if (filterValue !== null && filterValue !== undefined) {
          const filterGroup = new window.$.jqx.filter();
          const filterCondition = element.filters[0].condition ?? "CONTAINS";
          const filter = filterGroup.createfilter("stringfilter", filterValue, filterCondition);
          filterGroup.addfilter(1, filter);
          window.$(gridRefs[activeTab].current).jqxGrid("addfilter", element.datafield, filterGroup);
        }
      });
      window.$(gridRefs[activeTab].current).jqxGrid("applyfilters");
      localStorage.removeItem("srFilter");
    }
  };

  const loadDetails = async (id, pos) => {
    let endPoint;
    if (pos == 'E') {
      endPoint = `shipment-export/get-cargo-details/${id}`
    } else {
      endPoint = `shipment-export/get-export-details/${id}`
    }
    try {
      const res = await withRFSToken.get(endPoint, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          if (pos === 'E') {
            localStorage.setItem('EditCargo', JSON.stringify(innerData));
            localStorage.setItem('ccbackUrl', JSON.stringify('/ForwarderShipments/Export'));
            history.push('/ForwarderShipments/CreateCargo');
          } else {
            setSelectedRowData(innerData);

            setTimeout(() => {
              window.$(gridRefs[activeTab].current).jqxGrid('refresh');
            }, 30);
          }

        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleCloseClick = () => {
    setSelectedRowData(null);
    setTimeout(() => {
      window.$(gridRefs[activeTab].current).jqxGrid('refresh');
    }, 30);
  };

 

  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);

  // Driver Modal State
  const [driverModal, setDriverModal] = useState(false);
  const [driverData, setDriverData] = useState({
    driver_name: '',
    trucking_company: '',
    acn_id: '',
    vehicle_id: '',
    trailer_id: '',
    remarks: ''
  });

 
  
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };

  const findPrimary = selectedRowData?.attachments;

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };

  
  const resetFilters = () => {
    window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
  };

  // Driver Modal Functions
  const showDriverModal = () => {
    setDriverModal(true);
    setDriverData({
      driver_name: '',
      trucking_company: '',
      acn_id: '',
      vehicle_id: '',
      trailer_id: '',
      remarks: ''
    });
  };

  const hideDriverModal = () => {
    setDriverModal(false);
    setDriverData({
      driver_name: '',
      trucking_company: '',
      acn_id: '',
      vehicle_id: '',
      trailer_id: '',
      remarks: ''
    });
  };

  const handleDriverChange = (field, value) => {
    setDriverData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleDriverSave = async () => {
    // Validation
    if (!driverData.driver_name?.trim()) {
      toast.error('Driver Name is required');
      return;
    }
    if (!driverData.org_name?.trim()) {
      toast.error('Trucking Company is required');
      return;
    }
    if (!driverData.acn_id?.trim()) {
      toast.error('ACN ID is required');
      return;
    }

    try {
      const res = await withRFSToken.post(`${process.env.REACT_APP_RFS_URL}forwarder-shipment-planning/save-driver`, driverData);
      if (res.data?.response_code === 200) {
        toast.success('Driver saved successfully');
        hideDriverModal();
        // Refresh the grid
        if (gridRefs[activeTab]?.current) {
          window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
        }
      } else {
        toast.error(res.data?.response_msg || 'Error saving driver');
      }
    } catch (error) {
      console.error('Error saving driver:', error);
      toast.error(error.response?.data?.response_msg || 'Error saving driver');
    }
  };

  return (
    <>
       {/* {galleryOpen && <GalleryView attachments={selectedRowData.attachments} attachment_sec='oa' onClose={closeGalleryModal} />} */}
     
        <div className="mb-3 nestedtabs rounded minh">
          <div className='d-flex'>
          <button className="addtruck me-2" variant="primary" onClick={showDriverModal}>
            <span> <FontAwesomeIcon icon={faPlus} /> Add Driver</span>
          </button>
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic" className="action me-2">
              <FontAwesomeIcon icon={faGear} /> Actions{" "}<FontAwesomeIcon icon={faChevronDown} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={console.log("")}>
                + Add Shift
              </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
        </div>
        </div>
        <div className="maindiv">
            <div className='trashdonload position-relative'>
            {/* <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
                {!isLoading && <>
                    {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                    <div ref={gridRefs.Active} className='bookinggrid' ></div>
                </>
                }
                </Tab>
                <Tab eventKey="Archived" title={<span>Archived <Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                </Tab>
            </Tabs> */}
            {!isLoading && <>
                    {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                    <div ref={gridRefs.Active} className='bookinggrid' ></div>
                </>
                }
            </div>
            {selectedRowData && (
            <div className='SecondDiv mt-45'>
                <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                <div className='girddtals_header'>
                <h3>
                    {selectedRowData.label_id} &nbsp; <span>{selectedRowData.status}</span>
                </h3>
                <div className='d-flex actbtn'>
                    <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                </div>

                </div>
                <div className='mt-3'>
                <div className='mb-3'>
                    <h3>Highlighted Image(s)</h3>
                    {selectedRowData?.attachments && (
                    <>
                        <div className="g_parent">
                        {findPrimary.slice(0, 5).map((file, index) => {
                            let classN = '';
                            if (findPrimary.length === 1) {
                            classN = 'double'
                            } else if (findPrimary.length === 2) {
                            classN = 'double'
                            } else if (findPrimary.length === 3) {
                            classN = 'third'
                            } else if (findPrimary.length > 3) {
                            classN = 'more'
                            }
                            return (
                            <>
                                <div className={`${classN}${index + 1}`}>
                                <img
                                    src={file.file_path}
                                    alt="Preview"
                                    style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",

                                    }}

                                    onClick={() =>
                                    handleFileClick(file.file_path)
                                    }
                                />
                                </div>
                            </>
                            )
                        })}
                        {findPrimary.length > 5 && (
                            <div className='more'>
                            <button className="more-btn" onClick={showGalleryModal}>
                                +{findPrimary.length - 5}
                            </button>
                            </div>
                        )}
                        </div>
                    </>
                    )}
                </div>
                <div>
                    <h3>Shipment Information</h3>
                    <ul className='truck_info'>
                    <li><span>Address LBL :</span> <span>{selectedRowData.address_lbl}</span></li>
                    <li><span>DG :</span> <span>{selectedRowData.dg}</span></li>
                    <li><span>DG LBL :</span> <span>{selectedRowData.dg_lbl}</span></li>
                    <li><span>Accepted By :</span> <span>{selectedRowData.accepted_by}</span></li>
                    <li><span>Security :</span> <span>{selectedRowData.security}</span></li>
                    <li><span>Remarks :</span> <span>{selectedRowData.remarks}</span></li>
                    <li><span>Damage :</span> <span>{selectedRowData.damage}</span></li>
                    <li><span>Station :</span> <span>{selectedRowData.station}</span></li>

                    </ul>
                </div>
                </div>

                <ImageUpload
                ref={imageUploadRef}
                attachable_type={"einstock"}
                attachable_id={selectedRowData.awbId}
                attachments={selectedRowData.attachments}
                onDeleteSuccess={() => loadDetails(selectedRowData.awbId)}
                />
                <ActivityComments
                commentable_type={"einstock"}
                commentable_id={selectedRowData.awbId}
                allactivities={selectedRowData.activities}
                onReloadDetails={loadDetails}
                />
            </div>
            )}
        </div>
                  
       <Modal show={driverModal} centered onHide={hideDriverModal} className='addfrom' >
              <Modal.Header closeButton>
                  <Modal.Title>
                      Add Driver
                  </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <Form.Group as={Row} className='mb-2'>
                      <Col sm="12">
                          <Form.Label>Driver Name <span>*</span></Form.Label>
                          <Form.Control type="text" name='driver_name' placeholder="Add Driver Name" value={driverData.driver_name} onChange={(e) => handleDriverChange('driver_name', e.target.value)} />
                      </Col>
                  </Form.Group>
                  <Form.Group as={Row} className='mb-2'>
                      <Col sm="12">
                          <Form.Label>Trucking Company <span>*</span></Form.Label>
                          <Form.Control type="text" name='org_name' placeholder="Add Trucking Company" value={driverData.org_name} onChange={(e) => handleDriverChange('org_name', e.target.value)} />
                      </Col>
                  </Form.Group>
                  <Form.Group as={Row} className='mb-2'>
                      <Col sm="6">
                          <Form.Label>ACN ID <span>*</span></Form.Label>
                          <Form.Control type="text" name='acn_id' placeholder="Add ACN ID" value={driverData.acn_id} onChange={(e) => handleDriverChange('acn_id', e.target.value)} />
                      </Col>
                      <Col sm="6">
                          <Form.Label>Vehicle ID</Form.Label>
                          <Form.Control type="text" name='vehicle_id' placeholder="Add Vehicle ID" value={driverData.vehicle_id} onChange={(e) => handleDriverChange('vehicle_id', e.target.value)} />
                      </Col>
                  </Form.Group>

                  <Form.Group as={Row} className='mb-2'>
                      <Col sm="12">
                          <Form.Label>Trailer ID</Form.Label>
                          <Form.Control type="text" name='trailer_id' placeholder="Add Trailer ID" value={driverData.trailer_id} onChange={(e) => handleDriverChange('trailer_id', e.target.value)} />
                      </Col>
                  </Form.Group>
                  <Form.Group as={Row} className='mb-2'>
                      <Col sm="12">
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control type="text" name='remarks' placeholder="Add Remarks" value={driverData.remarks} onChange={(e) => handleDriverChange('remarks', e.target.value)} />
                      </Col>
                  </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                  <div className='d-flex w-50 mx-auto are_bottom'>
                      <Button variant="secondary" onClick={hideDriverModal}>
                          Discard
                      </Button>
                      <Button variant="primary" onClick={handleDriverSave}>
                          Save
                      </Button>
                  </div>
              </Modal.Footer>
          </Modal>
    </>
  )
}

export default DriverPlanning